import styles from './CPFInput.module.css'


export default function CPFCNPJInput({ value, onChange, text = 'CPF/CNPJ:' }) {

    return (
        <div className={styles.div}>
            <label style={{ paddingRight: '2px' }}>{text} </label>
            <input
                className={styles.input}
                // placeholder="_ _ _ . _ _ _ . _ _ _ - _ _"
                type="input"
                value={value}
                onChange={onChange}
            />
        </div>
    )
}